function bannerGroupsInlineStyleGroup(_ref) {
  var _ref$group = _ref.group,
      groupBg = _ref$group.groupBg,
      groupBorderRadius = _ref$group.groupBorderRadius,
      groupBorderColor = _ref$group.groupBorderColor,
      groupPadding = _ref$group.groupPadding,
      groupBorderWidth = _ref$group.groupBorderWidth,
      groupInheritBg = _ref$group.groupInheritBg,
      antiAdBlocker = _ref.customCss.antiAdBlocker;
  return {
    className: antiAdBlocker === "y" ? undefined : "rcb-group",
    style: {
      background: groupInheritBg ? undefined : groupBg,
      border: groupBorderWidth > 0 ? "".concat(groupBorderWidth, "px solid ").concat(groupBorderColor) : undefined,
      padding: groupPadding.map(function (p) {
        return "".concat(p, "px");
      }).join(" "),
      borderRadius: +groupBorderRadius,
      textAlign: "left"
    }
  };
}

export { bannerGroupsInlineStyleGroup };